var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "929.84 324.99800000000005 16.98829784871657 17.001000000000033",
    width: 12.99,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M940.08 326.65C939.52 327.22 936.7 330.03 931.63 335.11L931.59 335.27L931.01 338.21L930.84 339L931.63 338.83L934.57 338.25L934.73 338.21C939.81 333.14 942.62 330.32 943.19 329.76C944.05 328.89 944.04 327.5 943.18 326.64C942.77 326.23 942.21 326 941.63 326C941.05 326 940.49 326.24 940.08 326.65ZM942.44 327.4C942.88 327.75 942.95 328.39 942.61 328.84C942.56 328.9 942.5 328.95 942.44 329C942.41 329.03 942.28 329.15 942.05 329.37L940.47 327.79C940.69 327.56 940.81 327.43 940.84 327.4C941.04 327.17 941.33 327.03 941.64 327.02C941.95 327.03 942.23 327.17 942.44 327.4ZM939.72 328.54L941.3 330.13C937.42 334.01 935.27 336.16 934.84 336.59C934.49 335.91 933.93 335.36 933.25 335.01C934.11 334.14 936.27 331.99 939.72 328.54ZM932.57 335.88C933.2 336.13 933.71 336.64 933.97 337.28C933.85 337.3 933.26 337.42 932.21 337.63C932.4 336.69 932.52 336.11 932.57 335.88Z",
    id: "a6GVtbolRs"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6GVtbolRs",
    opacity: 1,
    fill: "#00787A",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6GVtbolRs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.524ffef8a3fbf8b6e12d08673af23107.svg";
export { ForwardRef as ReactComponent };